<template>
  <v-container>
    <!-- Complete Blood Count -->
    <div class="align-center pt-2">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >ผลการตรวจนับเม็ดเลือดแบบสมบูรณ์ (Complete Blood Count)</span
      >
    </div>
    <v-data-table
      class="elevation-1 my-table mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers"
      :items="bloodCount"
      :hide-default-footer="true"
    >
      <template v-slot:item.listTreatment
        ><td style="text-align: left">ปริมาณฮีโมโกลบิน (HB)</td>
      </template>
      <template v-slot:item.treatment="props">
        <v-text-field
          v-model="props.item.blood.completeBloodCount.hb"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุผลตรวจ"
          class="ma-2 textfield-sty"
          color="#00A99D"
          @keypress="validateNumber"
          type="number"
        ></v-text-field
      ></template>
      <template v-slot:item.value>M 13.0-18.0 g/dl <br>F 12.7-16.9 g/dl</template>
      <template v-slot:body.append="props">
        <!-- ---- 1.1 ---- -->
        <tr>
          <td>ปริมาณฮีมาโตคริต (Hct)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.hct"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">M 40.0-54.0 %<br>F 37.0-47.0 %</td>
        </tr>
        <!-- ---- 1.2 RBC---- -->
        <tr>
          <td>ปริมาณเม็ดเลือดแดง (RBC)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.rbc"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <!-- <td style="text-align: center">4-6 10<sup>6</sup> cu.mm</td> -->
          <td style="text-align: center">M 4.5-6.3 cu.mm<br/>F 4.2-5.5 10<sup>6</sup> cu.mm</td>
        </tr>
        <!-- ---- WBC---- -->
        <tr>
          <td>ปริมาณเมล็ดเลือดขาว (WBC)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.wbc"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">M 4,500-10,000 cells/mm<br/>F 4,500-10,000 cells/mm</td>
        </tr>
        <tr
          v-for="item in props.items"
          :key="item.id"
          style="background-color: #f2fcf5"
        >
          <td v-show="item.expanded2 != null">
            <span style="color: #00a99d">ชนิดเมล็ดเลือดขาว</span>
          </td>
          <td v-show="item.expanded2 != null"></td>
          <td v-show="item.expanded2 != null" style="text-align: right">
            <v-btn icon @click="toggleExpand2(item)">
              <v-icon color="#00a99d">{{
                isExpanded2(item) ? "mdi-chevron-down" : "mdi-chevron-up"
              }}</v-icon>
            </v-btn>
          </td>
        </tr>
        <!-- ---- Neutrophil---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded2">
          <td>นิวโตรฟิล (Neutrophil)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.neutrophil"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">M 40-70 %<br/>F 40-70 %</td>
        </tr>
        <!-- ---- Lymphocyte---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded2">
          <td>ลิมโฟไซท์ (Lymphocyte)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.lymphocyte"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">M 20-50 %<br/>F 20-50 %</td>
        </tr>
        <!-- ---- Monocyte---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded2">
          <td>โมโนไซท์ (Monocyte)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.monocyte"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">M 2-10 %<br/>F 2-10 %</td>
        </tr >
        <!-- ---- Eosinophi---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded2">
          <td>อีโอสิโนฟิล (Eosinophil)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.eosinophi"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">M 1-6 %<br/>F 1-6 %</td>
        </tr>
        <!-- ---- Basophil---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded2">
          <td>เบโซฟิล (Basophil)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.basophil"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">M 0-1 %<br/>F 0-1 %</td>
        </tr>
        <!-- ---- Platelet---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded2">
          <td>จำนวนเกล็ดเลือด (Platelet)</td>
          <td>
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.platelet"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
           <td style="text-align: center">M 150,000 -450,000 cells/mm<br/>F 150,000 -450,000 cells/mm</td>
        </tr>
        <!-- RBC Index -->
        <tr
          v-for="item in props.items"
          :key="item.id"
          style="background-color: #f2fcf5"
        >
          <td v-show="item.expanded != null">
            <span style="color: #00a99d">RBC Index</span>
          </td>
          <td v-show="item.expanded != null"></td>
          <td v-show="item.expanded != null" style="text-align: right">
            <v-btn icon @click="toggleExpand(item)">
              <v-icon color="#00a99d">{{
                isExpanded(item) ? "mdi-chevron-down" : "mdi-chevron-up"
              }}</v-icon>
            </v-btn>
          </td>
        </tr>
        <!-- ---- 1 ---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded">
          <td :colspan="columns.length">
            <span style="color: #00a99d"
              ><v-icon style="color: #00a99d">mdi-circle-small</v-icon>MCV</span
            >
          </td>
          <td :colspan="columns.length" v-show="item.expanded != null">
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.mcv"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td
            :colspan="columns.length"
            v-show="item.expanded != null"
            style="text-align: center"
          >
            M 80.0-97.0fl.<br/>F 80.0-97.0 fl.
          </td>
        </tr>
        <!-- ---- 2 ---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded">
          <td :colspan="columns.length">
            <span style="color: #00a99d"
              ><v-icon style="color: #00a99d">mdi-circle-small</v-icon>MCH</span
            >
          </td>
          <td :colspan="columns.length" v-show="item.expanded != null">
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.mch"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td
            :colspan="columns.length"
            v-show="item.expanded != null"
            style="text-align: center"
          >
            M 27.0-33.0 pg.<br/>F 27.0-33.0 pg.
          </td>
        </tr>
        <!-- ---- 3 ---- -->
        <tr v-for="item in props.items" :key="item.id" v-show="item.expanded">
          <td :colspan="columns.length">
            <span style="color: #00a99d"
              ><v-icon style="color: #00a99d">mdi-circle-small</v-icon
              >MCHC</span
            >
          </td>
          <td :colspan="columns.length" v-show="item.expanded != null">
            <v-text-field
              v-model="props.items[0].blood.completeBloodCount.mchc"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td
            :colspan="columns.length"
            v-show="item.expanded != null"
            style="text-align: center"
          >
            M 31.0-35.0 g/dl<br/>F 31.0-35.0 g/dl
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- ----------------- -->
    <div style="margin-top: 30px"></div>
    <!-- RBC Morphology -->
    <div class="align-center mt-3 pt-3">
      <span
        class="pl-2"
        style="font-size: 16px; font-weight: bold; color: #333333"
        >ลักษณะรูปร่างเม็ดเลือดแดง (RBC Morphology)</span
      >
    </div>
    <v-col cols="12" class="pl-1 pr-1">
      <v-textarea
        v-model="bloodCount[0].blood.completeBloodCount.rbcMorphology"
        outlined
        placeholder="รายละเอียดเพิ่มเติม"
        color="#00A99D"
      ></v-textarea>
    </v-col>
    <div class="align-center">
      <span
        class="pl-2"
        style="font-size: 16px; font-weight: bold; color: #333333"
        >สรุปผลตรวจนับเม็ดเลือดแบบสมบูรณ์ (Complete Blood Count)</span
      >
    </div>
    <v-col cols="12" class="pl-1 pr-1">
      <v-textarea
        v-model="bloodCount[0].blood.completeBloodCount.summaryBloodCount"
        outlined
        placeholder="รายละเอียดเพิ่มเติม"
        color="#00A99D"
      ></v-textarea>
    </v-col>
  </v-container>
</template>

<script>
import { EventBus } from "../../EventBus";
export default {
  data() {
    return {
      columns: ["Name"],
      headers: [
        {
          text: "รายการตรวจ",
          align: "center",
          sortable: false,
          value: "listTreatment",
        },
        {
          text: "ผลตรวจ",
          align: "center",
          sortable: false,
          value: "treatment",
        },
        {
          text: "ค่าปกติ",
          align: "center",
          sortable: false,
          value: "value",
        },
      ],
      bloodCount: [
        {
          expanded: true,
          expanded2: true,
          blood: {
            completeBloodCount: {
              hb: "",
              hct: "",
              rbc: "",
              wbc: "",
              neutrophil: "",
              lymphocyte: "",
              monocyte: "",
              eosinophi: "",
              basophil: "",
              platelet: "",
              mcv: "",
              mch: "",
              mchc: "",
              rbcMorphology: "",
              summaryBloodCount: "",
            },
          },
        },
      ],
    };
  },
  created() {
    this.detailAll();
  },
  methods: {
    toggleExpand(item) {
      item.expanded = !item.expanded;
    },
    isExpanded(item) {
      return item.expanded;
    },
    toggleExpand2(item) {
      item.expanded2 = !item.expanded2;
    },
    isExpanded2(item) {
      return item.expanded2;
    },
    detailAll() {
      EventBus.$on("detailAll_GetOneForm", (item) => {
        if (item !== undefined && item !== null) {
          this.bloodCount[0].blood.completeBloodCount =
            item.bloodCount.completeBloodCount;
        } else {
          this.bloodCount = [
            {
              expanded: true,
              expanded2: true,
              blood: {
                completeBloodCount: {
                  hb: "",
                  hct: "",
                  rbc: "",
                  wbc: "",
                  neutrophil: "",
                  lymphocyte: "",
                  monocyte: "",
                  eosinophi: "",
                  basophil: "",
                  platelet: "",
                  mcv: "",
                  mch: "",
                  mchc: "",
                  rbcMorphology: "",
                  summaryBloodCount: "",
                },
              },
            },
          ];
        }
      });
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        event.preventDefault();
      }
    },
  },
  beforeDestroy() {
    EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
.my-table thead th {
  background: #00a99d !important;
  color: #ffffff !important;
  &:first-child {
    border-radius: 10px 0 0 0;
  }
  &:last-child {
    border-radius: 0 10px 0 0;
  }
}
.textfield-sty {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.btn-sty {
  border-radius: 10px;
}

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button, 
::v-deep input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
    -moz-appearance: textfield;
}
</style>
